import { AnimatePresence, motion } from 'framer-motion'

import { useNavContext } from 'context/nav-context'
import { useAppContext } from 'context/app-context'
import { Li, Nav } from './styled'
import { smoothScroll } from 'utils'

export const PageNav = () => {
  const { isFooterVisible } = useAppContext()
  const { items, visibleItem } = useNavContext()

  return (
    <AnimatePresence>
      {!isFooterVisible && (
        <Nav
          as={motion.nav}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <ul>
            {items.map(el => {
              const title = el.getAttribute('data-title')

              return (
                <Li
                  key={title}
                  isActive={title === visibleItem?.getAttribute('data-title')}
                >
                  <button
                    disabled={title === visibleItem?.getAttribute('data-title')}
                    onClick={() => smoothScroll(el.offsetTop - 100, 100)}
                  >
                    {title}
                  </button>
                </Li>
              )
            })}
          </ul>
        </Nav>
      )}
    </AnimatePresence>
  )
}
